module.exports = __webpack_public_path__ + "media/images/home/demo_left2-4929d202218860959f6d4e73276b459a.png";